export const defaultState = {
    requestId: null,
};

export default function user(state = defaultState, action) {
    switch (action.type) {
        case 'OPEN_COMMENTS':
            return {
                ...state,
                requestId: action.payload.requestId,
            };
        case 'CLOSE_COMMENTS':
            return {
                ...state,
                requestId: null,
            };
        default:
            return state;
    }
}
